import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Používáme soubory cookie',
    description:
      'Používáme soubory cookie a podobné technologie pro fungování tohoto prostředí. Nezbytně nutné soubory cookie jsou vždy aktivní.',
    allow_label: 'Přijmout všechny soubory cookie',
    reject_label: 'Pouze nezbytně nutné',
    settings_label: 'Nastavení souborů cookie',
    policy_link_label: 'Zásady ochrany soukromí a souborů cookie',
    categories_label: 'Kategorie',
    always_on_label: 'Vždy aktivní',
    required_label: 'Povinné',
    save_preferences_label: 'Uložit předvolby',
    close_label: 'Zavřít',
    allow_all_optional_categories_label: 'Povolit všechny volitelné kategorie',
    settings_title: 'Nastavení souborů cookie',
    settings_description:
      'Používáme soubory cookie a podobné technologie pro fungování tohoto prostředí. Nezbytně nutné soubory cookie jsou vždy aktivní.',
    save_error: 'Vaši volbu ochrany soukromí se nepodařilo uložit. Zkuste to prosím znovu.'
  },
  categories: {
    strictly_necessary: {
      name: 'Nezbytně nutné',
      purpose: 'Jsou nutné pro fungování tohoto prostředí a nelze je vypnout.'
    },
    analytics: { name: 'Analytika', purpose: 'Měří, jak návštěvníci toto prostředí používají, aby se zlepšil výkon.' },
    marketing: { name: 'Marketing', purpose: 'Podporuje reklamu a marketing zvolené organizátorem.' }
  }
};

export default locale;
